/* eslint-disable array-callback-return */
import React, { Component } from "react";
import TableSAS from "./table";
import Grid from "@material-ui/core/Grid";
import { FormControl, InputLabel } from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateCard } from "../../redux/actions";
import SugestoesService from "../../services/sugestoes";

class Sugestoes extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      content: { data: [] },
      mensagemError: "",
      error: false,
    };
  }

  async componentDidMount() {
    this.get();
  }

  async get() {
    const content = await SugestoesService.get();
    try {
      if (content.status === 200) {
        this.setState({ content: content, loading: false });
      } else {
        this.setState({ error: true, loading: false });
      }
    } catch (error) {
      this.setState({ error: true, loading: false });
    }
    this.setState({ loading: false });
  }

  render() {
    const { loading, error, content } = this.state;

    if (loading) {
      return <div>Carregando...</div>;
    }
    if (error) {
      return <div>Erro de servidor, tente mais tarde!.</div>;
    }

    return (
      <div style={{ padding: 20 }}>
        <Grid container>
          <Grid item xs={5} sm={5}>
            <FormControl>
              <InputLabel htmlFor="age-simple">
                Sugestões dos Usuários para Cursos, Eventos e Conteúdos
              </InputLabel>
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <br />
        <TableSAS content={content} rowsTable={[]} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateCard }, dispatch);

const mapStateToProps = (store) => ({
  editCard: store.data.editCard,
});

export default connect(mapStateToProps, mapDispatchToProps)(Sugestoes);
